import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var ListContainer = function (_a) {
    var adSlot = _a.adSlot, className = _a.className, items = _a.items, styleOverride = _a.styleOverride;
    return (React.createElement("div", { className: "" + cn("ListContainer", className) },
        adSlot,
        items.map(function (item, index) { return (React.createElement("div", { className: cn("ListItemContainer", styles.listItemContainer, styleOverride), key: index }, item)); })));
};
export default ListContainer;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/listContainer/index.tsx
// module id = aqOB
// module chunks = 3